import { getResourceSlugFromType } from "~/modules/link-parser";
import { createComponent } from "react-fela";
import { combineRules } from "fela";
import get from "lodash.get";
import { textStyles } from "~/styleguide/typography";
import WordpressLink from "~/components/global/links";

export default ({ resource, type }) => {
    const glossaryTerm = get(resource, "glossary-term");
    const typeURL = getResourceSlugFromType(resource.type || type);


    return (
            <TextOnlyCard>
                {/* Title */}
                <WordpressLink
                    url={`/${typeURL}`}
                    slug={resource.slug}
                    label={glossaryTerm}
                    extend={boldReadMore}
                />
            </TextOnlyCard>
    );
};

//Sort-of a one-off? Might want to turn this into a generic h* style

const textOnlyTitle = {
    textTransform: "capitalize",
    "&:hover": {
      textDecoration: "underline"
    }
};

const boldReadMore = combineRules(textStyles.paragraphLarge, textOnlyTitle);

const TextOnlyCard = createComponent(() => ({
    display: "flex",
    paddingV: 12,
}));
